import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import React from 'react';

const ConfirmDeleteModal = ({
  open,
  onClose,
  onConfirm,
  employeeName,
  loading = false,
}) => {
  if (!open) return null;

  return (
    // <div className="modal modal-open">
    //   <div className="modal-box max-w-sm">
    //     <h3 className="font-bold text-lg mb-4">Remove Employee</h3>
    //     <p>
    //       Are you sure you want to remove{' '}
    //       <span className="font-semibold">
    //         {employeeName || 'this employee'}
    //       </span>{' '}
    //       from the campaign?
    //     </p>
    //     <div className="modal-action">
    //       <button
    //         className="btn btn-ghost"
    //         onClick={onClose}
    //         disabled={loading}
    //       >
    //         Cancel
    //       </button>
    //       <button
    //         className="btn btn-error"
    //         onClick={onConfirm}
    //         disabled={loading}
    //       >
    //         {loading ? (
    //           <>
    //             <span className="loading loading-spinner loading-sm"></span>
    //             Removing...
    //           </>
    //         ) : (
    //           'Remove'
    //         )}
    //       </button>
    //     </div>
    //   </div>
    // </div>
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
    <DialogTitle>
      Remove Employee
    </DialogTitle>
    <DialogContent>
      <Typography variant="body1" sx={{ mb: 2 }}>
        Are you sure you want to remove{' '}
        <span style={{ fontWeight: 600 }}>
          {employeeName || 'this employee'}
        </span>{' '}
        from the campaign?
      </Typography>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} disabled={loading}>
        Cancel
      </Button>
      <Button
        onClick={onConfirm}
        color="error"
        variant="contained"
        disabled={loading}
      >
        {loading ? (
          <>
            <CircularProgress size={20} sx={{ mr: 1 }} />
            Removing...
          </>
        ) : (
          'Remove'
        )}
      </Button>
    </DialogActions>
  </Dialog>

  );
};

export default ConfirmDeleteModal;
